const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default class ImageWithHotspots {

  // Constructor
  constructor(section) {

    this.imageSection = section

    if (!this.imageSection) {
      return;
    }

    this.imageDetail = this.imageSection.querySelector('.section-image-with-hotspots--detail')

    this.imageWrapper = this.imageSection.querySelector('.section-image-with-hotspots--image-wrapper')
    this.imageContent = this.imageSection.querySelector('.section-image-with-hotspots--image-container')

    this.handlePinClick = this.handlePinClick.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleSectionClick = this.handleSectionClick.bind(this)

    this.detailClose = this.imageDetail.querySelector('.detail-close')
    this.detailClose.addEventListener('click', this.handleCloseClick)

    let sectionPins = Array.from(this.imageSection.querySelectorAll('.section-image-with-hotspots--pin'))

    let self = this

    sectionPins.forEach((sectionPin) => {
      sectionPin.addEventListener('click', (function(sectionPin) {
        return function(e) {
          self.handlePinClick(e, sectionPin)
        }
      })(sectionPin))
    })

    this.handleLoad = this.handleLoad.bind(this)
    window.addEventListener('DOMContentLoaded', this.handleLoad)

    this.resize = this.resize.bind(this)
    window.addEventListener('resize', this.resize)
  }

  handlePinClick(e, sectionPin) {
    const trigger = sectionPin
    this.currentTrigger = trigger

    this.populateDetail()
      .then(() => {

        disableBodyScroll(this.imageDetail)

        document.body.classList.add('section-image-with-hotspots--detail-ready')

        requestAnimationFrame(() => {
          document.body.classList.add('section-image-with-hotspots--detail-active')
        })

        document.addEventListener('keyup', this.handleKeyUp)

        setTimeout(() => {
          this.imageSection.addEventListener('click', this.handleSectionClick)
        })
      })
  }

  handleKeyUp(e) {
    if (e.keyCode !== 27) {
      return;
    }

    this.closeDetail()
  }

  handleCloseClick() {
    this.closeDetail()
  }

  handleSectionClick(e) {
    if (e.target.closest('.section-image-with-hotspots--detail')) {
      return;
    }

    this.closeDetail()
  }

  closeDetail() {

    document.removeEventListener('keyup', this.handleKeyUp)
    this.imageSection.removeEventListener('click', this.handleSectionClick)

    document.body.classList.remove('section-image-with-hotspots--detail-active')

    this.imageSection.classList.remove()

    let animationTimeout;
    let animationEndHandler = () => {
      clearTimeout(animationTimeout)
      animationTimeout = setTimeout(() => {
        document.body.classList.remove('section-image-with-hotspots--detail-ready')  
      }, 150)      
    }

    this.returnFocus()

    // if (window.innerWidth <= 768) {
    enableBodyScroll(this.imageDetail)
    // }
  }

  returnFocus() {
    if (this.currentTrigger) {
      this.currentTrigger.focus()
      this.currentTrigger = null
    }
  }

  populateDetail() {

    let waitTimeout = 0

    return new Promise((resolve) => {
      let titleElem = this.imageDetail.querySelector('[data-title]')
      let copyElem = this.imageDetail.querySelector('[data-copy]')
      let headerImgContainer = this.imageDetail.querySelector('[data-header-img]')
      let pinNumberElem = this.imageDetail.querySelector('[data-pin-number]')
      let pinRuleElem = this.imageDetail.querySelector('[data-pin-rule]')

      titleElem.innerHTML = this.currentTrigger.dataset.title
      

      let copy = this.currentTrigger.dataset.copy
      // Temp copy to see it in place
      if (!copy) {
        copy = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ante eros, efficitur ac gravida quis, fringilla in risus. Integer semper nisl vitae euismod malesuada.'
      }

      copyElem.innerHTML = copy

      let pinNumber = this.currentTrigger.dataset.pinNumber
      if (pinNumber) {
        pinNumberElem.innerHTML = this.currentTrigger.dataset.pinNumber
        pinNumberElem.classList.remove('u-display-none')
      } else {
        pinNumberElem.classList.add('u-display-none')
      }

      let pinColorA = this.currentTrigger.dataset.pinColorA
      let pinColorB = this.currentTrigger.dataset.pinColorB
      if (pinColorA) {
        pinRuleElem.style.color = this.currentTrigger.dataset.pinColorA
        pinRuleElem.classList.remove('u-display-none')

        if (pinColorB) {
          pinRuleElem.style.background = `linear-gradient(to left, ${ pinColorB } 50%, ${pinColorA} 50%)`
        } else {
          pinRuleElem.style.background = `${pinColorA}`
        }
      } else {
        pinRuleElem.classList.add('u-display-none')
      }

      if (this.currentTrigger.dataset.image) {
        headerImgContainer.innerHTML = `<img src="${this.currentTrigger.dataset.image}">`
        // Give the image a little time to load. Not waiting for the load event incase there's an error
        waitTimeout = 500
        headerImgContainer.classList.remove('no-image')
      } else {
        headerImgContainer.classList.add('no-image')
        let headerImg = headerImgContainer.querySelector('img')
        if (headerImg) {
          headerImg.remove()
        }
      }

      setTimeout(() => {
        resolve()
      }, waitTimeout)
    })
  }

  handleLoad() {
    // set the scroll position to center the graphic horizontally
    this.imageWrapper.scrollLeft = (this.imageContent.getBoundingClientRect().width / 2) - (window.innerWidth / 2)
  }

  // Public Methods
  resize() {
    if (window.innerWidth >= 768) {
      enableBodyScroll(this.imageDetail)
    }
  }
}
